import "../../index24.css";
import { jsx as v } from "react/jsx-runtime";
import { useRef as d } from "react";
import { _ as g } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import m from "../../hooks/useSpacingToken.js";
import { paddingSpacings as p } from "../../utils/style.js";
const f = "_heading_iyj7h_1", u = "_center-aligned_iyj7h_11", j = "_with-light-background_iyj7h_15", w = "_with-bottom-border_iyj7h_19", y = "_level-one_iyj7h_23", B = "_level-two_iyj7h_31", T = "_level-three_iyj7h_39", x = "_level-four_iyj7h_48", F = "_level-five_iyj7h_52", k = "_level-six_iyj7h_56", z = "_ellipsized_iyj7h_62", e = {
  heading: f,
  centerAligned: u,
  withLightBackground: j,
  withBottomBorder: w,
  levelOne: y,
  levelTwo: B,
  levelThree: T,
  levelFour: x,
  levelFive: F,
  levelSix: k,
  ellipsized: z
}, S = {
  1: e.levelOne,
  2: e.levelTwo,
  3: e.levelThree,
  4: e.levelFour,
  5: e.levelFive,
  6: e.levelSix
};
function R(t) {
  const {
    className: n,
    level: i = 3,
    children: o,
    ellipsize: r,
    centerAligned: s,
    variant: l = "container",
    spacing: c
  } = t, _ = m({
    spacing: c,
    modes: p
  }), h = `h${i}`, a = d(null);
  return o ? /* @__PURE__ */ v(
    h,
    {
      className: g(
        e.heading,
        r && e.ellipsized,
        S[i],
        s && e.centerAligned,
        l === "form" && _,
        l === "form" && e.withBottomBorder,
        l === "form" && e.withLightBackground,
        n
      ),
      ref: a,
      children: o
    }
  ) : null;
}
export {
  R as default
};
